export { DMS_MODULE } from '../../constants';
export const CRUMB_LABEL_KEY = 'edtTyp';
export const NAME = 'Typ';
